export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/a6bf0ad36e700bb31f6714c905f959a1.png";